const DownloadType = {
  RAW: 'raw',
  SIMILARITIES_JSON: 'similarities_json',
  SIMILARITY_DATA_JSON: 'similarity_data_json',
  SPELL_RESULT_JSON: 'spell_result_json',
  IMAGE_PATH: 'image_path_json',
  GENERAL_REPORT: 'general_report',
  HIGHLIGHT_REPORT: 'highlight_report',
  SPELL_REPORT: 'spell_report',
  ABNORMAL_REPORT: 'abnormal_report',
}
const ReportType = {
  SUMMARY: 'summary',
  HIGHLIGHT: 'highlight',
}

const IgnoreUserFormMode = {
  EDIT: 'edit',
  NEW: 'new',
}

const DeleteType = {
  SOFT: 'soft',
  FORCE: 'force',
}

const SortPlagMode = {
  SEQUENCE: 'sequence',
  SCORE_ASC: 'scoreAsc',
  SCORE_DESC: 'scoreDes',
}

const PlagScoreType = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
}

const RouteNames = {
  TAG_MANAGEMENT: 'tag-management',
  GROUP_MANAGEMENT: 'group-management',
  DOCUMENTS_IN_GROUP_MANAGEMENT: 'documents-in-group-management',
  DOCUMENTS_IN_TAG_MANAGEMENT: 'documents-in-tag-management',
  USER_DOCUMENTS_MANAGEMENT: 'user-documents-management',
  ADMIN_DOCUMENTS_MANAGEMENT: 'admin-documents-management',
  ADMIN_USERS_MANAGEMENT: 'admin-users-management',
  TRIVIAL_SENTENCE_MANAGEMENT: 'trivial-sentence-management',
  TRIVIAL_CANDIDATE_SENTENCE_MANAGEMENT: 'trivial-candidate-sentence-management',
  IMPORT_DATA: 'importData',
  LOGIN: 'login',
}

const ContentType = {
  formData: 'multipart/form-data',
  json: 'application/json',
}
// high >= 90
// medium >=80
// low >= 70

const Authentication = {
  ACCESS_TOKEN_HEADER: 'jwt',
  REFRESH_TOKEN_HEADER: 'jwt-refresh',
  ACCESS_TOKEN_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh-token',
  DOCUMENT_PERMISSION: 'document_permission',
  TAG_PERMISSION: 'tag_permission',
  USER_INFO: 'user_info',
  CLIENT_ID: 'webClient',
  CLIENT_SECRET: 'secret',
}

const IgnoreReasonDescriptions = {
  TOO_SHORT: 'Câu văn quá ngắn',
  NOT_MAIN_CONTENT: 'Không phải nội dung chính',
  INVALID_DICTIONARY: 'Câu văn chứa nhiều từ không xác định',
  INVALID_FORMAT: 'Câu văn có định dạng bất thường',
}

const Permission = {
  READ: 'READ',
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  ADMIN: 'ADMIN',
  MODIFY_RESULT: 'MODIFY_RESULT',
  VIEW: 'VIEW',
  COMMENT: 'COMMENT',
  REPORT: 'REPORT',
  SHARE: 'SHARE',
  OWNER: 'OWNER',
}

const TagPermissions = {
  READ: {
    label: 'Đọc',
    value: 'READ',
    description: 'Xem thông tin trạng thái tài liệu',
    required: true,
  },
  EDIT: {
    label: 'Sửa',
    value: 'EDIT',
    description: 'Chỉnh sửa thông tin tài liệu',
    required: false,
  },
  VIEW: {
    label: 'Xem',
    value: 'VIEW',
    description: 'Xem chi tiết kết quả, tải báo cáo',
    required: false,
  },
  /*COMMENT: {
        label: "Bình luận",
        value: "COMMENT",
        description: "Bình luận về kết quả chi tiết",
        required: false,
    },*/
  REPORT: {
    label: 'Báo cáo',
    value: 'REPORT',
    description: 'Báo cáo kết quả',
    required: false,
  },
  SHARE: {
    label: 'Chia sẻ',
    value: 'SHARE',
    description: 'Chia sẻ với người khác',
    required: false,
  },
}

const TagSharePermissions = {
  VIEW: {
    label: 'Xem',
    value: 'VIEW',
    description: 'Xem chi tiết và tải báo cáo',
    required: false,
  },
  EDIT: {
    label: 'Sửa',
    value: 'EDIT',
    description: 'Chỉnh sửa thông tinn thư mục',
    required: false,
  },
}

const Role = {
  ROLE_USER: 'ROLE_USER',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_TEACHER: 'ROLE_TEACHER',
  ROLE_STUDENT: 'ROLE_STUDENT',
}

const ObjectType = {
  DOCUMENT: 'Document',
  Tag: 'Tag',
}

const DocumentTypes = {
  DOCUMENT: 'document',
  GROUP_DOCUMENT: 'group-document',
}

const ReasonIgnoredBySystemType = {
  NOT_MAIN_CONTENT: {
    type: 'NOT_MAIN_CONTENT',
    name: 'Không phải nội dung chính',
  },
  MUC_LUC: {
    type: 'MUC_LUC',
    name: 'Phần mục lục',
  },
  DS_BANG: {
    type: 'DS_BANG',
    name: 'Phần danh sách bảng',
  },
  DS_HINH_ANH: {
    type: 'DS_HINH_ANH',
    name: 'Phần danh sách hình ảnh',
  },
  LOI_CAM_ON: {
    type: 'LOI_CAM_ON',
    name: 'Phần lời cảm ơn',
  },
  CAM_DOAN: {
    type: 'CAM_DOAN',
    name: 'Phần lời cam đoan',
  },
  TL_THAM_KHAO: {
    type: 'TL_THAM_KHAO',
    name: 'Phần tài liệu tham khảo',
  },
  MO_DAU: {
    type: 'MO_DAU',
    name: 'Phần mở đầu',
  },
  DS_HINH_BANG: {
    type: 'DS_HINH_BANG',
    name: 'Phần hình ảnh và bảng',
  },
  DS_VIET_TAT: {
    type: 'DS_VIET_TAT',
    name: 'Phần danh sách viết tắt',
  },
  TOM_TAT: {
    type: 'TOM_TAT',
    name: 'Phần tóm tắt',
  },
  DS_SO_DO: {
    type: 'DS_SO_DO',
    name: 'Phần danh sách sơ đồ',
  },
  PHU_LUC: {
    type: 'PHU_LUC',
    name: 'Phần phụ lục',
  },
  HEADING: {
    type: 'HEADING',
    name: 'Phần tiêu đề',
  },
  COVER: {
    type: 'COVER',
    name: 'Trang bìa',
  },
  TRIVIAL: {
    type: 'TRIVIAL',
    name: 'Từ thông dụng',
  },
  CITATION: {
    type: 'CITATION',
    name: 'Phần tài liệu trích dẫn',
  },
}

const ReasonIgnoreTypes = {
  system_detect_wrong: {
    type: 'system_detect_wrong',
    name: 'Hệ thống phát hiện sai',
  },
  referenced: {
    type: 'referenced',
    name: 'Đã ghi nguồn trích dẫn',
  },
  other: {
    type: 'other',
    name: 'Lý do khác',
  },
}

const SourceIgnoredReasons = {
  OTHER: 'other',
}

const DocumentState = {
  DELETED: 'DELETED',
  STOPPED: 'STOPPED',
  ERROR: 'ERROR',
  CREATED: 'CREATED',
  START_PROCESS: 'START_PROCESS',
  START_PDF_CONVERT: 'START_PDF_CONVERT',
  DONE_PDF_CONVERT: 'DONE_PDF_CONVERT',
  START_DOC_EXTRACT: 'START_DOC_EXTRACT',
  DONE_DOC_EXTRACT: 'DONE_DOC_EXTRACT',
  START_REPORT_GENERATE: 'START_REPORT_GENERATE',
  DONE_REPORT_GENERATE: 'DONE_REPORT_GENERATE',
  COMPLETE_PROCESS: 'COMPLETE_PROCESS',
  PENDING_ANALYZE: 'PENDING_ANALYZE',
  REQUESTED_ANALYZE: 'REQUESTED_ANALYZE',
  START_DOC_ANALYSE: 'START_DOC_ANALYSE',
  DONE_DOC_ANALYSE: 'DONE_DOC_ANALYSE',
  CREDIT_PENDING: 'CREDIT_PENDING',
  START_INDEX: 'START_INDEX',
  DONE_INDEX: 'DONE_INDEX',
  get PROCESSING_STATE() {
    return [
      this.CREATED,
      this.START_PROCESS,
      this.START_PDF_CONVERT,
      this.DONE_PDF_CONVERT,
      this.START_DOC_EXTRACT,
      this.DONE_DOC_EXTRACT,
      this.START_REPORT_GENERATE,
      this.DONE_REPORT_GENERATE,
      this.PENDING_ANALYZE,
      this.REQUESTED_ANALYZE,
      this.START_DOC_ANALYSE,
      this.CREDIT_PENDING,
      this.START_INDEX,
      this.DONE_INDEX,
    ]
  },
  get DELETABLE_STATES(){
    return [
        this.COMPLETE_PROCESS,
        this.ERROR,
    ]
  }
}

const DocumentStateType = [
  {
    state_id: -1,
    name: 'DELETED',
    descriptionAdmin: 'Đã xóa',
    descriptionUser: 'Đã xóa',
    processing: false,
  },
  {
    state_id: -3,
    name: 'STOPPED',
    descriptionAdmin: 'Đã xóa',
    descriptionUser: 'Đã xóa',
    processing: false,
  },
  {
    state_id: -2,
    name: 'ERROR',
    descriptionAdmin: 'Có lỗi xảy ra',
    descriptionUser: 'Có lỗi xảy ra',
    processing: false,
  },
  {
    state_id: 0,
    name: 'CREATED',
    descriptionAdmin: 'Đã tạo',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 2,
    name: 'START_PROCESS',
    descriptionAdmin: 'Bắt đầu xử lý',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 3,
    name: 'START_PDF_CONVERT',
    descriptionAdmin: 'Đang convert pdf',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 4,
    name: 'DONE_PDF_CONVERT',
    descriptionAdmin: 'Đã convert pdf',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 5,
    name: 'START_DOC_EXTRACT',
    descriptionAdmin: 'Đang tách câu',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 6,
    name: 'DONE_DOC_EXTRACT',
    descriptionAdmin: 'Đã tách câu',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 7,
    name: 'START_DOC_ANALYSE',
    descriptionAdmin: 'Đang phân tích',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 8,
    name: 'DONE_DOC_ANALYSE',
    descriptionAdmin: 'Đã phân tích',
    descriptionUser: 'Đã xử lý',
    processing: true,
  },
  {
    state_id: 1,
    name: 'COMPLETE_PROCESS',
    descriptionAdmin: 'Đã xử lý',
    descriptionUser: 'Đã xử lý',
    processing: false,
  },
  {
    state_id: 12,
    name: 'PENDING_ANALYZE',
    descriptionAdmin: 'Đang chờ phân tích',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 13,
    name: 'REQUESTED_ANALYZE',
    descriptionAdmin: 'Đã yêu cầu phân tích',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 18,
    name: 'CREDIT_PENDING',
    descriptionAdmin: 'Đang chờ thanh toán',
    descriptionUser: 'Đang xử lý',
    processing: false,
  },
  {
    state_id: 19,
    name: 'START_INDEX',
    descriptionAdmin: 'Đang đánh chỉ mục',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 20,
    name: 'DONE_INDEX',
    descriptionAdmin: 'Đã đánh chỉ mục',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
]

const ComponentType = {
  GROUPDOCUMENT: 'groupDocument',
  DOCUMENT: 'document',
}

const GroupState = {
  ERROR: 'ERROR',
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  START_PROCESS: 'START_PROCESS',
  DOCUMENT_EXTRACTING: 'DOCUMENT_EXTRACTING',
  DOCUMENT_EXTRACTED: 'DOCUMENT_EXTRACTED',
  START_INDEXING: 'START_INDEXING',
  DONE_INDEXING: 'DONE_INDEXING',
  START_SEARCHING: 'START_SEARCHING',
  DONE_SEARCHING: 'DONE_SEARCHING',
  COMPLETE_PROCESS: 'COMPLETE_PROCESS',
  get PROCESSING_STATE() {
    return [
      this.CREATED,
      this.START_PROCESS,
      this.DOCUMENT_EXTRACTING,
      this.DOCUMENT_EXTRACTED,
      this.START_INDEXING,
      this.DONE_INDEXING,
      this.START_SEARCHING,
      this.DONE_SEARCHING,
    ]
  },
}

const GroupStateType = [
  {
    state_id: -2,
    name: 'ERROR',
    descriptionAdmin: 'Có lỗi xảy ra',
    descriptionUser: 'Có lỗi xảy ra',
    processing: false,
  },
  {
    state_id: -1,
    name: 'DELETED',
    descriptionAdmin: 'Đã xóa',
    descriptionUser: 'Đã xóa',
    processing: false,
  },
  {
    state_id: 0,
    name: 'CREATED',
    descriptionAdmin: 'Đã tạo',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 2,
    name: 'START_PROCESS',
    descriptionAdmin: 'Đang xử lý',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 3,
    name: 'DOCUMENT_EXTRACTING',
    descriptionAdmin: 'Đang tách câu',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 4,
    name: 'DOCUMENT_EXTRACTED',
    descriptionAdmin: 'Đã tách câu',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 5,
    name: 'START_INDEXING',
    descriptionAdmin: 'Indexing',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 6,
    name: 'DONE_INDEXING',
    descriptionAdmin: 'Indexed',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 7,
    name: 'START_SEARCHING',
    descriptionAdmin: 'Bắt đầu tìm kiếm',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 8,
    name: 'DONE_SEARCHING',
    descriptionAdmin: 'Hoàn thành tìm kiếm',
    descriptionUser: 'Đang xử lý',
    processing: true,
  },
  {
    state_id: 1,
    name: 'COMPLETE_PROCESS',
    descriptionAdmin: 'Đã xử lý',
    descriptionUser: 'Đã xử lý',
  },
]

const maxFileUpload = {
  DocumentCreate: 5,
  GroupDocumentCreate: 5,
  GroupCreate: 1,
}

const Table = {
  RELOAD_INTERVAL: 15 * 1000,
}

const TableItemActionType = {
  EDIT: 'edit',
  case: 'edit',
}

const reloadGroupType = {
  IGNORE_SENTENCE: 'IGNORE_SENTENCE',
  ENABLE_SENTENCE: 'ENABLE_SENTENCE',
  UNDO_ACTION: 'UNDO_ACTION',
  IGNORE_SOURCE: 'IGNORE_SOURCE',
}

const DocumentSourceType = {
  WEB: 'WEB',
  GROUP: 'GROUP',
  THESIS: 'THESIS',
}

const ResultViewMode = {
  PLAGIARISM: 'plagiarismMode',
  SPELL: 'spellingMode',
}

const IgnoredSourceType = {
  URL: 'url',
  DOMAIN: 'domain',
}

const DateTime = {
  DATE_TIME_FORMAT: 'HH:mm:ss DD/MM/YYYY',
  DATE_FORMAT: 'DD/MM/YYYY',
  DAY_MONTH_FORMAT: 'DD/MM/YYYY',
}

const Colors = {
  INFO: 'darkslategray',
  RETRY: 'darkblue',
  RAW: 'gray',
  REPORT: '#0063fa',
  SEND: 'green',
  EDIT: 'darkorange',
  DELETE: 'orangered',
  WHITE: 'white',
  BLACK: '#222222',
  ALERT: 'orangered',
  MAIN_THEME: '#3d5396',
  SUCCESS: 'forestgreen',
  BLUE: 'darkblue',
  DISABLED: '#aaa',
}

export {
  IgnoredSourceType,
  ResultViewMode,
  DocumentSourceType,
  reloadGroupType,
  SortPlagMode,
  PlagScoreType,
  Authentication,
  ObjectType,
  Permission,
  DocumentStateType,
  Role,
  DownloadType,
  DeleteType,
  ReportType,
  ReasonIgnoreTypes,
  TagPermissions,
  ContentType,
  RouteNames,
  TagSharePermissions,
  IgnoreReasonDescriptions,
  DocumentState,
  GroupState,
  GroupStateType,
  ComponentType,
  maxFileUpload,
  IgnoreUserFormMode,
  SourceIgnoredReasons,
  Table,
  DateTime,
  DocumentTypes,
  Colors,
  ReasonIgnoredBySystemType,
}
